import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { Header } from 'src/app/shared/components/header/header.model';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  labelCaption: any;
  headerData: Header = new Header();
  userId:any;
  constructor(private utilitiesService: UtilitiesService, private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    //Get label caption
    let data = this.utilitiesService.GetLabelCaption(
      this.activatedRoute.snapshot.data.labelCaptionData,
      'Module_AboutUs'
    );
    if (data && data['Label']) {
      this.labelCaption = data['Label'];
    }
    this.userId = sessionStorage.getItem('userId');
    //Set header data for post login
    if(this.userId){
    this.headerData.isHeaderRight = true;
    }
    //Set scroll
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }

  onClickToRedirectToHome(){
   
    //Post login
    if(this.userId){
      this.router.navigate(['creditorhome']);
    }
    else{
      this.router.navigate(['']);
    }
  }
}
